import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { faGithub, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import logo from '../assets/logo.png';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="mt-16 border-t border-zinc-800/80 bg-dark-500/90 py-12 text-white">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
        {/* Brand & Tagline */}
        <div className="flex items-center gap-3">
          <img src={logo} className="w-9 h-9 rounded-full border border-teal-500/40" alt="logo" />
          <div className="flex flex-col text-left">
            <span className="font-bold text-base text-white">Syam R S</span>
            <span className="text-xs text-gray-400">Staff Cloud Platform Engineer &amp; Architect</span>
          </div>
        </div>

        {/* Quick Nav Links */}
        <nav className="flex flex-wrap justify-center items-center gap-6 text-sm text-gray-400">
          <a href="#home" className="hover:text-teal-300 transition-colors">About</a>
          <a href="#experience" className="hover:text-teal-300 transition-colors">Experience</a>
          <a href="#projects" className="hover:text-teal-300 transition-colors">Projects</a>
          <a href="#skills" className="hover:text-teal-300 transition-colors">Skills</a>
          <a href="#certs" className="hover:text-teal-300 transition-colors">Certifications</a>
          <a href="#contact" className="hover:text-teal-300 transition-colors">Contact</a>
        </nav>

        {/* Socials & Back to Top */}
        <div className="flex items-center gap-3">
          <a
            href="https://github.com/syam-rs"
            target="_blank"
            rel="noreferrer"
            className="w-9 h-9 rounded-lg bg-dark-200 border border-zinc-800 flex items-center justify-center text-gray-400 hover:text-teal-400 hover:border-teal-500/40 transition-colors"
            title="GitHub"
          >
            <FontAwesomeIcon icon={faGithub} />
          </a>
          <a
            href="https://www.linkedin.com/in/syam-r-s01/"
            target="_blank"
            rel="noreferrer"
            className="w-9 h-9 rounded-lg bg-dark-200 border border-zinc-800 flex items-center justify-center text-gray-400 hover:text-teal-400 hover:border-teal-500/40 transition-colors"
            title="LinkedIn"
          >
            <FontAwesomeIcon icon={faLinkedinIn} />
          </a>
          <a
            href="mailto:syam.rs01@gmail.com"
            className="w-9 h-9 rounded-lg bg-dark-200 border border-zinc-800 flex items-center justify-center text-gray-400 hover:text-teal-400 hover:border-teal-500/40 transition-colors"
            title="Email"
          >
            <FontAwesomeIcon icon={faEnvelope} />
          </a>
          <button
            onClick={scrollToTop}
            className="w-9 h-9 rounded-lg bg-dark-200 border border-zinc-800 flex items-center justify-center text-gray-400 hover:text-teal-400 hover:border-teal-500/40 transition-colors"
            title="Back to Top"
          >
            <FontAwesomeIcon icon={faArrowUp} className="text-xs" />
          </button>
        </div>
      </div>

      <div className="mt-8 pt-6 border-t border-zinc-800/50 text-center text-xs text-gray-500">
        &copy; {currentYear} Syam R S. All Rights Reserved. Built with React &amp; Tailwind CSS.
      </div>
    </footer>
  );
}
